// Copyright (c) 2026 Goffy. This file belongs to Goffy. All Rights Reserved.

// Tour-only composite games (Eclectic, Freeze). They are computed across all
// rounds of a tour by the backend and are only selectable as tournament games —
// never as per-round games. GUIDs mirror WellKnownGameDefinitionIds.cs and the
// game-definition seeder.
export const ECLECTIC_GAME_ID = '3f6a1d9c-2b84-4e07-9d15-8c4a7e2f5b60';
export const FREEZE_GAME_ID = '9b4e7c21-6f5a-4d38-a1c9-0e8d3b6f7a52';

export const TOURNAMENT_ONLY_GAME_IDS: ReadonlySet<string> = new Set([
  ECLECTIC_GAME_ID,
  FREEZE_GAME_ID,
]);

export function isTournamentOnlyGameId(gameId?: string | null): boolean {
  if (typeof gameId !== 'string') return false;
  return TOURNAMENT_ONLY_GAME_IDS.has(gameId.trim().toLowerCase());
}

export function isTournamentOnlyGame(
  game?: { id?: string | null; gameType?: string | null } | null,
): boolean {
  if (!game) return false;
  if (isTournamentOnlyGameId(game.id)) return true;
  const gameType = typeof game.gameType === 'string' ? game.gameType.trim().toLowerCase() : '';
  return gameType === 'tour game';
}
